<div class="tag-input" [ngClass]="{'focus': isTagInputFocused }">
  <div class="tags-container scrollbar"
    #tagsContainer>

    <!-- Chips -->
    <app-chip
      *ngFor="let item of chips"
      class="email-chip"
      (removed)="removeChipByClick($event)"
      [info]="item"
      [regex]="chipRegex">
    </app-chip>

    <!-- Text input -->
    <input class="form-control email-input"
      type="text"
      (input)="handleValueChanged($event)"
      (keyup.backspace)="selectOrRemoveLastChip()"
      (keydown)="type($event)"
      (focus)="showTypeahead(); isTagInputFocused  = true"
      (blur)="addChip(); isTagInputFocused  = false"
      [placeholder]="(textInput === '' && chips.length === 0)  ? placeholder : ''"
      #searchInput
    />
    <label class="container-label">Email Address</label>
  </div>
</div>

<!-- Dropdown -->
<app-drop-hints
  class="drop-hints"
  [style.left]="getDropdownPositionOffset()"
  [hidden]="!isFoundResultSearchShown"
  (makeSuggestion)="takeSuggestion($event)"
  [suggestions]="suggestions"
  #dropSuggester>
</app-drop-hints>
